<template>
  <div>
    <div class="row m-b-40">
      <!-- DANGEROUS GOODS -->
      <div class="dg-card m-b-40 clear-float" v-if="showDgTypeBox">
        <div class="col-xs-12" v-if="!isIata">
          <InputSelect
            :label="$t('dg_document')"
            v-model="feeWrapperId"
            @change="onServiceChange"
            :options="getDangerousGoodsServices"
            :rules="{required: true}"/>
        </div>
        <div v-if="isIata">
          <div>
            <div class="col-xs-4">
              <InputSelect
                :label="$t('dg_document')"
                v-model="feeWrapperId"
                @change="onServiceChange"
                :options="getDangerousGoodsServices"
                :rules="{required: true}"/>
            </div>
            <div class="col-xs-4">
              <InputSelect
                :label="$t('limitations')"
                v-model="value.iataLimitations"
                :options="iataLimitationOptions"
                :rules="{required: true}"/>
            </div>
            <div class="col-xs-4">
              <InputSelect
                :label="$t('radioactive')"
                v-model="value.iataRadioactive"
                :options="iataRadiationOptions"
                :rules="{required: true}"/>
            </div>
            <div class="col-xs-12" style="padding-top: 15px">
              <InputText
                :label="$t('iata_additional_info')"
                v-model="value.iataAdditionalInfo"
                :rules="{required: false}"/>
            </div>
          </div>
        </div>
      </div>
      <div class="dg-card" v-if="value.isDgToggleActive && hasFeeWrapperId && serviceCategory && get_dangerous_goods_options.length">
        <!-- DANGEROUS GOODS Packaging type options -->
        <div class="m-b-40"  v-if="!isWithoutDoc">
          <div class="clear-float">
            <div :class="classPackagingType" v-if="!isIata && !isWithoutDoc">
              <InputSelect
                v-if="value.isDgToggleActive"
                :label="$t('packaging_type')"
                @change="onPackagingTypeOptionChange"
                v-model="value.packingTypeOption"
                :options="packagingTypeOptions"
                :rules="{required: true}"/>
            </div>
            <div :class="classIsOverpack" v-if="!isWithoutDoc">
              <InputSelect
                v-if="value.isDgToggleActive"
                :label="$t('overpack')"
                v-model="value.isOverpack"
                :options="isOverpackOptions" />
            </div>
            <div :class="classAllPackedInOne" v-if="!isWithoutDoc">
              <InputSelect
                v-if="value.isDgToggleActive"
                :label="$t('all_packed_in_one')"
                @change="onAllPackedInOneChange"
                v-model="value.allPackedInOne"
                :options="allPackedInOneOptions"
                :rules="{required: true}"/>
            </div>
          <div :class="classQty">
            <InputText
              v-if="parseInt(value.goodsType) === 3 && parseInt(value.allPackedInOne) === 1"
              :label="$t('qty.')"
              v-model="value.qty"
              :rules="{required: true}"/>
          </div>
          <div :class="classOuterPackaging">
            <InputSelect
              v-if="parseInt(value.allPackedInOne) === 1"
              :label="$t('outer_packaging')"
              v-model="value.packingType"
              :options="getDangerousGoodsPackingTypeOptions"
              :rules="{required: true}" />
          </div>
            <div class="col-xs-1">
              <InputText
                v-if="parseInt(value.allPackedInOne) === 1 && isIata"
                :label="$t('Q')"
                v-model="value.Q"
                :rules="{required: true}"/>
            </div>
          </div>
          </div>
        <div class="separator" style="width: 100%" v-if="!isWithoutDoc"></div>
        <DangerousGoodsRow
          v-for="(item, index) in value.dangerousGoodsServices" :key="`dg-row-${customId}-${index}`"
          :deletable="value.dangerousGoodsServices.length > 1"
          :indexInData="index"
          :colliId="customId"
          :serviceCategory="serviceCategory"
          :packingTypeOption="packingTypeOption"
          :allPackedInOne="allPackedInOne"
          :feeWrapperId="feeWrapperId"
          :goodsType="parseInt(value.goodsType)"
          @deleteRow="deleteDangerousGoodsRow(index)"
          v-model="value.dangerousGoodsServices[index]" />
        <div class="clear-float">
          <Btn v-if="value.isDgToggleActive"
               @click.native="addDangerousGoodsItem"
               class="brand float-left m-r-20"
               :icon="{name: 'plus', size: '20'}"
               :btnText="$t('add_dg')"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import InputText from '@/components/elements/inputs/text.vue';
import InputSelect from '@/components/elements/inputs/select.vue';
import mixin from "@/mixins/mixins";
import Btn from "@/components/elements/buttons/button";
import Toggle from "@/components/elements/inputs/toggle";
import DimensionsSelect from "@/components/elements/inputs/dimensionsSelect";
import WeightSelect from "@/components/elements/inputs/weightSelect";
import NestedSelect from "@/components/elements/inputs/nestedSelect";
import DangerousGoodsRow from "@/components/shipments/dangerousGoodsRow";
import {mapGetters} from "vuex";

export default {
  name: 'DangerousGoodsBlock',
  mixins: [mixin],
  components: {
    Btn,
    InputSelect,
    InputText,
    Toggle,
    DimensionsSelect,
    WeightSelect,
    NestedSelect,
    DangerousGoodsRow
  },
  props: {
    dgTypeShownOnPackageCustomId: {
      type: String,
      default: '',
    },
    customId: {
      type: String,
      default: '',
    },
    value: {
      type: Object,
      default: () => {
        return {
          colli: 1,
          description: '',
          parcelType: '',
          packagingName: '',
          colliWeight: {
            value: 0,
            unit: 'kg',
          },
          dimensions: {
            width: {
              value: 0,
              disabled: false,
            },
            height: {
              value: 0,
              disabled: false,
            },
            length: {
              value: 0,
              disabled: false,
            },
            dimensionsType: '',
          },
          isTemperature: false,
          minTemperature: '',
          maxTemperature: '',
          isDgToggleActive: false,
          qty: 1,
          Q: '',
          packingType: '',
          iataLimitations: '',
          iataRadioactive: '',
          iataAdditionalInfo: '',
          packingTypeOption: 2,
          isOverpack: 0,
          allPackedInOne: 2,
          dangerousGoodsServices: [
            {
              feeWrapperId: this.feeWrapperId,
              dangerousGoodsId: '',
              nemWeight: {
                unit: 'kg',
                value: null,
              },
              netWeight: {
                unit: 'kg',
                value: null,
              },
              bruttoWeight: {
                unit: 'kg',
                value: null,
              },
              englishTechnicalDesignation: '',
              danishTechnicalDesignation: '',
              iataAutorization: '',
              flashPoint: '',
              segregationGroup: '',
              ems: '',
              notAllInOneQty: '',
              notAllInOneOuterPackaging: '',
              innerPackaging: '',
              innerPackagingQty: '',
              packingInstruction: '',
              isEnvironmentalHazard: false,
              isMarinePollutant: false,
              isLimitedQuantity: false,
              isExceptedQuantity: false,
            }
          ],
          content: [
            {
              qty: 1,
              description: '',
              unitWeight: {
                value: '',
                unit: 'kg',
              },
              unitValue: {
                value: '',
                unit: 'dkk',
              },
              hsCode: '',
              origin: '',
            },
          ],
        }
      },
    }
  },
  data() {
    return {
      feeWrapperId: '',
      qty: 1,
      packingType: '',
      Q: '',
      iataLimitations: '',
      iataRadioactive: '',
      iataAdditionalInfo: '',
      serviceCategory: '',
      packingTypeOption: 2,
      isOverpack: 0,
      allPackedInOne: 2,
      shouldShowAdditionalFields: false,
      shouldShowEnvHazardToggle: false,
      shouldShowMarinePollutantToggle: false,
      isIata: false,
      isWithoutDoc: false,
      packagingTypeOptions: [
        {
          text: `${this.$t('packaging_combination')}`,
          value: 1,
        },
        {
          text: `${this.$t('packaging_single')}`,
          value: 2,
        },
      ],
      isOverpackOptions: [
        {
          text: `${this.$t('no')}`,
          value: 0,
        },
        {
          text: `${this.$t('yes')}`,
          value: 1,
        },
      ],
      allPackedInOneOptions: [
        {
          text: `${this.$t('yes')}`,
          value: 1,
        },
        {
          text: `${this.$t('no')}`,
          value: 2,
        },
      ],
      iataLimitationOptions: [
        {
          text: `${this.$t('passenger_and_cargo_aircraft')}`,
          value: 1,
        },
        {
          text: `${this.$t('cargo_aircraft_only')}`,
          value: 2,
        },
      ],
      iataRadiationOptions: [
        {
          text: `${this.$t('non_radioactive')}`,
          value: 1,
        },
        {
          text: `${this.$t('radioactive')}`,
          value: 2,
        },
      ],
    }
  },
  computed: {
    ...mapGetters([
      'get_dangerous_goods_options',
      'get_dangerous_goods_services',
      'get_dangerous_goods_service_by_id',
      'get_dangerous_goods_packing_types'
    ]),
    showDgTypeBox() {
      //Compare indexes
      const typePackageIndex = this.dgTypeShownOnPackageCustomId.replace(/^\D+/g, '');
      const currentPackageIndex = this.customId.replace(/^\D+/g, '');
      return this.value.isDgToggleActive && (!this.dgTypeShownOnPackageCustomId || (parseInt(typePackageIndex) === parseInt(currentPackageIndex)));
    },
    getDangerousGoodsPackingTypeOptions() {
      return this.get_dangerous_goods_packing_types.map((type) => {
        return {text: this.$t(type), value: type}
      });
    },
    getDangerousGoodsServices() {
      const categoryNames = {
        28: 'document_adr',
        29: 'document_iata',
        30: 'document_imdg',
        31: 'document_mou',
        32: 'document_without_doc',
      };
      const originalObject = this.get_dangerous_goods_services;
      return Object.keys(originalObject).map((key) => {
         const categoryId = originalObject[key].category;
         const categoryName = categoryNames[categoryId];
         console.log(categoryName)
         return {text: this.$t(categoryName), value: originalObject[key].value};
       })
    },
    hasFeeWrapperId() {
      return !!this.feeWrapperId;
    },
    classPackagingType() {
      if (this.allPackedInOne == 2) {
        return 'col-xs-4'
      } else if (this.value.allPackedInOne == 1) {
        return 'col-xs-3'
      } else {
        return 'col-xs-4'
      }
    },
    classIsOverpack() {
      if (this.allPackedInOne == 2) {
        return 'col-xs-3'
      } else if (this.value.allPackedInOne == 1) {
        return 'col-xs-2'
      } else {
        return 'col-xs-3'
      }
    },
    classAllPackedInOne() {
      if (this.allPackedInOne == 2 && !this.isIata) {
        return 'col-xs-5'
      } else if (this.allPackedInOne == 1) {
        return 'col-xs-2'
      } else if (this.isIata && this.allPackedInOne == 2) {
        return 'col-xs-9'
      } else if (this.isIata && this.allPackedInOne == '') {
        return 'col-xs-9'
      } else {
        return 'col-xs-6'
      }
    },
    classQty() {
      if (this.isIata) {
        return 'col-xs-3';
      } else {
        return 'col-xs-1'
      }
    },
    classOuterPackaging() {
      if (this.value.goodsType !== 3 && this.isIata) {
        return 'col-xs-7';
      } else if (this.value.goodsType !== 3) {
        return 'col-xs-5'
      } else {
        return 'col-xs-4'
      }
    }
  },
  methods: {
    onServiceChange(val) {
      this.setServiceCategory(val);
      if (this.value.isDgToggleActive && !this.value.dangerousGoodsServices?.length) {
        this.addDangerousGoodsItem();
      }
    },
    onPackagingTypeOptionChange(val) {
      if (this.packingTypeOption !== val){
        this.packingTypeOption = val
        //Reset inner qty and packaging if packaing type is single packaging
        if (parseInt(val) === 2) {
          this.$parent.$emit('packagingTypeOptionChange')
        }
      }
    },
    onAllPackedInOneChange(val) {
      if (this.allPackedInOne !== val) {
        this.allPackedInOne = val
      }
    },
    setServiceCategory (val) {
      if (!val) return;
      //28 = Adr - Dangerous Goods
      const service = this.get_dangerous_goods_service_by_id(val);
      this.serviceCategory = service?.category;
      this.isIata = parseInt(this.serviceCategory) === 29;
      this.isWithoutDoc = parseInt(this.serviceCategory) === 32;
      //if dg is IATA packingTypeOption will be always single
      this.value.packingTypeOption = this.isIata ? 2 : this.value.packingTypeOption;
    },
    deleteDangerousGoodsRow(index) {
      this.$parent.$emit('input', {
        ...this.value,
        dangerousGoodsServices: this.value.dangerousGoodsServices.filter((item, idx) => idx !== index),
      });
    },
    addDangerousGoodsItem() {
      this.$parent.$emit('input', {
        ...this.value,
        packingTypeOption: 2,
        dangerousGoodsServices: [
          ...this.value.dangerousGoodsServices,
          {
            feeWrapperId: this.feeWrapperId,
            dangerousGoodsId: '',
            nemWeight: {
              unit: 'kg',
              value: null,
            },
            netWeight: {
              unit: 'kg',
              value: null,
            },
            bruttoWeight: {
              unit: 'kg',
              value: null,
            },
            englishTechnicalDesignation: '',
            danishTechnicalDesignation: '',
            iataAutorization: '',
            flashPoint: '',
            segregationGroup: '',
            ems: '',
            notAllInOneQty: '',
            notAllInOneOuterPackaging: '',
            innerPackaging: '',
            innerPackagingQty: '',
            packingInstruction: '',
            isEnvironmentalHazard: false,
            isMarinePollutant: false,
            isLimitedQuantity: false,
            isExceptedQuantity: false,
          }
        ]
      });
    },
  },
  mounted() {
    //Copy or draft shipment
    if (this.value.dangerousGoodsServices?.length) {
      this.feeWrapperId = this.value.dangerousGoodsServices[0].feeWrapperId;
      this.setServiceCategory(this.feeWrapperId);
    }
    if (this.value.allPackedInOne) {
      this.onAllPackedInOneChange(this.value.allPackedInOne);
    }

    this.packingTypeOption = this.value.packingTypeOption;
  },
  watch: {
    'value.isTemperature'(newVal) {
      if(newVal == false) {
        this.$emit('input', {
          ...this.value,
          isTemperature: false,
          minTemperature: '',
          maxTemperature: '',
        });
      }
    },
    'value.dangerousGoodsServices': {
        handler(newVal, oldVal){
          if (newVal?.length && oldVal?.length) {
            this.feeWrapperId = newVal[0].feeWrapperId;
            this.setServiceCategory(this.feeWrapperId);
          }
        },
        deep: true
    },
    'feeWrapperId'(newVal, oldVal) {
      if (newVal && (newVal !== oldVal) && this.showDgTypeBox) {
        this.$parent.$emit('dgTypeChanged', {
          dgType: newVal,
          packageId: this.customId,
          iataLimitations: this.value.iataLimitations,
          iataRadioactive: this.value.iataRadioactive,
          iataAdditionalInfo: this.value.iataAdditionalInfo,
        })
      }
    },
    'value.iataLimitations'(newVal, oldVal) {
      if (newVal && (newVal !== oldVal) && this.showDgTypeBox) {
        this.$parent.$emit('dgTypeChanged', {
          dgType: this.feeWrapperId,
          packageId: this.customId,
          iataRadioactive: this.value.iataRadioactive,
          iataAdditionalInfo: this.value.iataAdditionalInfo,
          iataLimitations: newVal
        })
      }
    },
    'value.iataRadioactive'(newVal, oldVal) {
      if (newVal && (newVal !== oldVal) && this.showDgTypeBox) {
        this.$parent.$emit('dgTypeChanged', {
          dgType: this.feeWrapperId,
          packageId: this.customId,
          iataLimitations: this.value.iataLimitations,
          iataAdditionalInfo: this.value.iataAdditionalInfo,
          iataRadioactive: newVal
        })
      }
    },
    'value.iataAdditionalInfo'(newVal, oldVal) {
      if (newVal && (newVal !== oldVal) && this.showDgTypeBox) {
        this.$parent.$emit('dgTypeChanged', {
          dgType: this.feeWrapperId,
          packageId: this.customId,
          iataLimitations: this.value.iataLimitations,
          iataRadioactive: this.value.iataRadioactive,
          iataAdditionalInfo: newVal
        })
      }
    },
  },
}
</script>
